import { isNavigationFailure } from 'vue-router';
import { filter } from 'rxjs';
import { ErrorCode } from '@golden/gdk-base';
export const underMaintenanceGuard = (gdk, baseURL = '/') => {
    gdk.error.pipe(filter((error) => error.code === ErrorCode.PLAYER_MAINTENANCE))
        .subscribe((error) => {
        window.location.replace(`${baseURL}maintenance.html?time=${error.response.comment}&title=${error.response.title}`);
    });
};
export const accessRestrictedGuard = (gdk, router) => {
    gdk.error.pipe(filter((error) => error.code === ErrorCode.IP_NOT_IN_WHITELIST))
        .subscribe((error) => {
        void router.push({ path: '/access-restricted', query: { ip: error.response?.extra?.client_ip } }).catch((error) => { if (!isNavigationFailure(error, 16))
            throw error; });
    });
};
//# sourceMappingURL=WebGuard.js.map